import React from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  currencySymbol,
  formatPrice,
  getIsCreditPricing,
} from '@/features/subscription/components/utils';
import { TSubscription } from '@/features/subscription/apiSlice';
import { useSelector } from 'react-redux';

const lineItemPrice = (_price: number) => {
  return formatPrice(_price, false, null, true);
};

export const PlanSummary: React.FC<{ subscription: TSubscription }> = ({
  subscription,
}) => {
  const isCreditPricing = useSelector(getIsCreditPricing);
  if (!subscription.subscriptionStatus || isCreditPricing) return null;

  return (
    <div className={css.section}>
      <div className={`${flex.row} ${flex.alignItemsStart}`}>
        <div className={css.billingIcon}>
          <FontAwesomeIcon icon="receipt" />
        </div>
        <div className="w-100">
          <b>Plan summary</b>
          <div className={`${css.tableContainer} w-100`}>
            <table className={`table ${css.lineItems}`}>
              <thead>
                <tr>
                  <th>DESCRIPTION</th>
                  <th>QTY</th>
                  <th>UNIT PRICE ({currencySymbol(subscription.currency)})</th>
                  <th>AMOUNT ({currencySymbol(subscription.currency)})</th>
                </tr>
              </thead>
              <tbody className="table-striped">
                {subscription.lineItems.map((item, i) => {
                  const lineStyle = item.quantity === 0 ? { opacity: 0.4 } : {};
                  return (
                    <tr style={lineStyle} key={i}>
                      <td>{item.description}</td>
                      <td>{item.quantity}</td>
                      <td>
                        {item.unitPrice
                          ? lineItemPrice(item.unitPrice / 100)
                          : null}
                      </td>
                      <td>{lineItemPrice(item.amount / 100)}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td />
                  <td />
                  <td>
                    <b>Subtotal</b>
                  </td>
                  <td>
                    <b>
                      {lineItemPrice(
                        subscription.lineItems.reduce(
                          (sum, currentItem) => sum + currentItem.amount / 100,
                          0,
                        ),
                      )}
                    </b>
                  </td>
                </tr>
                {subscription.subtotalItems.map((item, i) => {
                  const happiness =
                    item.amount < 0 ? (
                      <img
                        style={{ width: '18px', marginRight: '3px' }}
                        src="/img/rocket-border-full.png"
                      />
                    ) : null;
                  return (
                    <tr key={i}>
                      <td />
                      <td />
                      <td>
                        {happiness}
                        {item.description}
                      </td>
                      <td>{lineItemPrice(item.amount / 100)}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td />
                  <td />
                  <td>
                    <b>Monthly total</b>
                  </td>
                  <td>
                    <b>
                      {lineItemPrice(
                        subscription.lineItems.reduce(
                          (sum, currentItem) => sum + currentItem.amount / 100,
                          0,
                        ) +
                          subscription.subtotalItems.reduce(
                            (sum, currentItem) =>
                              sum + currentItem.amount / 100,
                            0,
                          ),
                      )}
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
